import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import NovoGerador from './NovoGerador';
import FichaGerador from './FichaGerador';
import Loading from '../../../components/Loading/Loading';

//Api
import gerador_api from '../../../api/gerador_api';

//Helpers
import mascaras from '../../../helpers/mascaras';
import { showMessage } from '../../../helpers/message';
import { getSessionCookie } from '../../../helpers/cookies';

// Shared
import FiltroPrefeitura from '../../Shared/FiltroPrefeitura';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Context
import { useAuth } from '../../../context/auth';

export default function Geradores({ permissao }) {
    const { setupVariavel } = useAuth();

    //Dados do usuario logado
    const usuario = getSessionCookie();

    //Variavel para pegar dados que possam vir no state da rota
    const location = useLocation();

    //Cabeçalhos da tabela de listagem de geradores
    const [headersTabela, setHeadersTabela] = useState([
        { value: "Fantasia", objectValue: "fantasia", align: "left", },
        { value: "Razão Social", objectValue: "razao", align: "left" },
        { value: "CPF / CNPJ", objectValue: "cpfcnpj", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left", options: { display: false } },
        { value: "Status", objectValue: "status", align: "left" },
        { value: "Categoria", objectValue: "categoria", align: "left" },
        { value: "Ramo de atividade", objectValue: "ramoDeAtividade", align: "left" },
        { value: "Característica", objectValue: "caracteristica", align: "left" },
        { value: "Regionais", objectValue: "regionais", align: "left" }
    ]);

    const [cadastroExternoGerador, setCadastroExternoGerador] = useState(false)

    //Estado que guarda o id da prefeitura selecionada no select das prefeituras no ambiente privado ou da prefeitura default no ambiente público
    const [prefeitura_Id, setPrefeitura_Id] = useState(null);
    const handlePrefeitura = (value) => {
        setPrefeitura_Id(value);
        if (!!usuario)
            loadGeradores(value);
    }

    //Estado que gurada a lista de geradores
    const [geradores, setGeradores] = useState([]);

    //Estado de controle para exibição da tela de novo gerador
    const [novo, setNovo] = useState(false);
    const handleClickNovo = () => {
        if (!prefeitura_Id)
            showMessage("Aviso", "Selecione uma prefeitura para poder adicionar um novo gerador", "info");
        else
            setNovo(true);
    }

    useEffect(() => {
        if (location && location.state && location?.state?.cadastroExternoGerador == "Gerador" && !usuario) {
            setCadastroExternoGerador(true)
            setNovo(true)
        }
    }, []);

    //Estado de controle para exibição da tela de ficha do gerador
    const [ficha, setFicha] = useState(false);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Carrega os geradores para serem mostrados na tabela
    const loadGeradores = (prefeitura_id) => {
        setLoading(true);
        gerador_api.GetList(prefeitura_id).then(response => {
            response.data = response.data.map(gerador => {
                gerador.cpfcnpj = mascaras.cpfcnpjMask(gerador.cpfcnpj);
                return gerador;
            })
            setGeradores(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.visualizar((item) => setFicha(item.id))];

    //Controle da exibição da tela de novo cadastro
    if (novo && prefeitura_Id) {
        return <NovoGerador
            btnVoltar={cadastroExternoGerador == true ? null : () => { loadGeradores(prefeitura_Id); setNovo(false); }}
            prefeitura_id={prefeitura_Id}
            cadastroExternoGerador={cadastroExternoGerador}
            integracaoCadastros={setupVariavel?.integracaoCadastros}
        />
    }

    //Controle da exibição da tela de ficha
    if (ficha) {
        return <FichaGerador
            btnVoltar={() => {
                loadGeradores(prefeitura_Id);
                setFicha(false);
            }}
            id={ficha}
            permissao={permissao}
            integracaoCadastros={setupVariavel?.integracaoCadastros}
        />
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard
                noCard
                btnCadastro={
                    permissao === "Editar" && 
                    ( 
                        (!setupVariavel?.integracaoCadastros && usuario.acesso.sigla == "GS" && setupVariavel?.quemCadastraGeradores.includes("Secretaria"))  ||
                        (usuario.acesso.sigla == "TR")
                    ) ? "Adicionar" : null}
                visivel={!setupVariavel?.integracaoCadastros}
                onClickBtnCadastro={handleClickNovo}
            >
                <div className={`w-100 `}>
                    <div className='mt-4'>
                        <FiltroPrefeitura handleValue={handlePrefeitura} />
                        {!!usuario &&
                            <TabelaListagem
                                headers={headersTabela}
                                items={geradores}
                                actions={actions}
                                title="Lista de geradores"
                                options={{ print: false, search: true, pagination: true }}
                            />
                        }
                    </div>
                </div>
            </MainCard >
        </>
    )
}
